<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <div v-if="!(options.lists['pharmacies-wholesalers'] || []).length">
            <div class="card shadow mb-3">
                <div class="card-body">
                    Bitte eine Liste vom Typ <b>Apotheken mit Großhandel</b> anlegen!
                </div>
            </div>
        </div>

        <div v-else>
            <timing-period-module :dto="config.timing" :options="options" :compare="false"></timing-period-module>

            <div class="card shadow mb-3">
                <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
                </div>
                <div class="card-body">

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.liefer.wholesaler']"></i>
                            Großhändler
                        </label>
                        <custom-select v-model="config.wholesalerIds"
                                       :settings="wholesalerSettings"
                                       :options="wholesalers"/>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.liefer.einkauf']"></i>
                            Preisfilter
                        </label>
                        <select class="form-control" v-model="config.einkaufFilter">
                            <option value="disabled">Keiner</option>
                            <option value="between">Listen EK zwischen</option>
                        </select>
                    </div>

                    <div class="row" v-if="config.einkaufFilter !== 'disabled'">
                        <div class="col">
                            <div class="form-group">
                                <label>Min</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.einkaufMin">
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Max</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.einkaufMax">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.spezial.periodMode']"></i>
                            Zeitraum Modus
                        </label>
                        <select class="form-control" v-model="config.periodMode">
                            <option value="sum">Summe</option>
                            <option value="monthly">Monatlich</option>
                        </select>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="alert alert-info" role="alert">
                        <i class="fas fa-fw fa-info"></i>
                        {{ $info['gh.apoListe'] }}
                    </div>

                    <filtering-module :dto="config.filtering"
                                      :options="options"
                                      :pharmacies="true"
                                      :warengruppen="true"
                                      :dar="true"
                                      :menge="true"
                                      :wirkstoffe="true"
                                      :reimport="true"></filtering-module>
                </div>
            </div>
        </div>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../../Modules/TimingPeriodModule";
import FilteringModule from "../../Modules/FilteringModule";
import PharmacyFilterModule from "../../Modules/PharmacyFilterModule";

export default {
    components: {FilteringModule, TimingPeriodModule, PharmacyFilterModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
            wholesalerSettings: {
                multiple: true,
                tags: false,
            }
        };
    },
    computed: {
        wholesalers() {
            return [
                {
                    id: 13,
                    text: 'Partner Pharma Logistik PPL-GmbH'
                },
                {
                    id: 14,
                    text: 'MEDI-SPEZIAL Arzt- und Praxis-Service GmbH'
                },
                {
                    id: 15,
                    text: 'JM-Pharma GmbH'
                },
                {
                    id: 17,
                    text: 'PROVEN Diagnostik und Service GmbH'
                },
                {
                    id: 18,
                    text: 've[do]no GmbH'
                },
                {
                    id: 19,
                    text: 'BestPhago GmbH'
                },
                {
                    id: 20,
                    text: 'MTS Meditel Service GmbH'
                },
                {
                    id: 23,
                    text: 'CPL Pharma Lager und Vertrieb GmbH'
                },
                {
                    id: 24,
                    text: 'spangropharm GmbH & Co. KG'
                },
            ];
        }
    }
}
</script>
